import ContactCountsCell from '../ContactCountsCell'
import { CellInfo } from '../types'

export const ContactStatusCell = (info: CellInfo) => {
  const {
    row: { original: profileData },
    meta: { companyContactsMap, onContactStatusClick },
  } = info

  const isProfileActive = profileData.profileStatus === 'active'
  const contactsOverview = companyContactsMap[profileData.companyId]

  if (!contactsOverview || !isProfileActive) {
    return null
  }

  return (
    <ContactCountsCell
      companyId={profileData.companyId}
      contactsOverview={contactsOverview}
      onExpandClick={ref => onContactStatusClick(ref, profileData.companyId)}
    />
  )
}
